import angular from 'angular';
import EndpointHelper from 'ShbDeployer/helpers/endpointHelper';

angular.module('shbdeployer.app').controller('EndpointsController', EndpointsController);

function EndpointsController($q, $scope, $state, $async, EndpointService, GroupService, ModalService, Notifications, EndpointProvider, StateManager) {
  $scope.state = {
    loadingMessage: '',
  };

  $scope.setLoadingMessage = setLoadingMessage;
  function setLoadingMessage(message) {
    $scope.state.loadingMessage = message;
  }

  $scope.removeAction = removeAction;
  function removeAction(endpoints) {
    ModalService.confirmDeletion('Будут удалены все настройки, связанные с выбранными окружениями. Продолжить?', (confirmed) => {
      if (!confirmed) {
        return;
      }
      return $async(removeActionAsync, endpoints);
    });
  }

  async function removeActionAsync(endpoints) {
    for (let endpoint of endpoints) {
      try {
        await EndpointService.deleteEndpoint(endpoint.Id);

        Notifications.success('Готово', 'Окружение «' + endpoint.Name + '» успешно удалено');
      } catch (err) {
        Notifications.error('Ошибка', err, 'Не удалось удалить окружение');
      }
    }

    const endpointId = EndpointProvider.endpointID();
    // Если удалено текущее окружение — сбрасываем его в состоянии приложения
    if (endpoints.some((item) => item.Id === endpointId)) {
      StateManager.cleanEndpoint();
      // Принудительная перерисовка боковой панели
      $scope.applicationState.endpoint = {};
    }

    $state.reload();
  }

  $scope.getPaginatedEndpoints = getPaginatedEndpoints;
  function getPaginatedEndpoints(lastId, limit, search) {
    const deferred = $q.defer();
    $q.all({
      endpoints: EndpointService.endpoints(lastId, limit, { search }),
      groups: GroupService.groups(),
    })
      .then(function success(data) {
        var endpoints = data.endpoints.value;
        var groups = data.groups;
        EndpointHelper.mapGroupNameToEndpoint(endpoints, groups);
        deferred.resolve({ endpoints: endpoints, totalCount: data.endpoints.totalCount });
      })
      .catch(function error(err) {
        Notifications.error('Ошибка', err, 'Не удалось получить сведения об окружениях');
      });
    return deferred.promise;
  }
}
